import { registerAuthoredPairClip, type AuthoredPairClip } from '../../shared/game/pair-clips.js';
// Generated by `npm run anim` from src/content/animation/clips.json: add a clip there (npm run anim -- new), not here.
import { testPairClip } from './test.js';
import { testPairPairClip } from './test-pair.js';
import { testPair2PairClip } from './test-pair2.js';
import { testPair3PairClip } from './test-pair3.js';
import { testPair4PairClip } from './test-pair4.js';
import { test2PairClip } from './test2.js';
import { test3PairClip } from './test3.js';
import { test4PairClip } from './test4.js';

/** Every authored pair clip, registered as a kind of meeting (`World.meet(id, ...)`, a scenario's `meet` beat). */
export const authoredPairs: AuthoredPairClip[] = [
  testPairClip,
  testPairPairClip,
  testPair2PairClip,
  testPair3PairClip,
  testPair4PairClip,
  test2PairClip,
  test3PairClip,
  test4PairClip,
];
for (const clip of authoredPairs) registerAuthoredPairClip(clip);
